import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-totp.magic.css.js';
import script from './keycloak-totp.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"part":"wrapper"}},[_c('magic-ui-text',{staticClass:"description",attrs:{"part":"description","tag":"p","content":_vm.$t('keycloak-totp.descrption')}}),_vm._v(" "),_c('div',{staticClass:"keycloak-step1 step",attrs:{"part":"keycloak-step1 step"}},[_c('magic-ui-text',{staticClass:"step-title",attrs:{"part":"step-title","tag":"h2","content":_vm.$t('keycloak-totp.step1.title')}}),_vm._v(" "),_c('magic-ui-text',{attrs:{"tag":"p","content":_vm.$t('keycloak-totp.step1.description')}}),_vm._v(" "),_c('ul',{staticClass:"supported-devices"},_vm._l((_vm.supportedApplications),function(supportedApplication,index){return _c('li',{key:index},[_vm._v("\n                "+_vm._s(supportedApplication)+"\n            ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"keycloak-step2 step",attrs:{"part":"keycloak-step2 step"}},[_c('magic-ui-text',{staticClass:"step-title",attrs:{"part":"step-title","tag":"h2","content":_vm.$t('keycloak-totp.step2.title')}}),_vm._v(" "),_c('magic-ui-text',{attrs:{"tag":"p","content":_vm.$t('keycloak-totp.step2.description')}}),_vm._v(" "),_c('div',{staticClass:"qr-code"},[_c('img',{attrs:{"src":("data:image/png;base64, " + _vm.totpSecretQrCode),"alt":"Figure: Barcode"}})]),_vm._v(" "),_c('magic-ui-link',{staticClass:"link",attrs:{"part":"link","href":_vm.totpManualURL}},[_vm._v("\n            "+_vm._s(_vm.$t('keycloak-totp.unable-to-scan'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"keycloak-step3 step",attrs:{"part":"keycloak-step3 step"}},[_c('magic-ui-text',{staticClass:"step-title",attrs:{"part":"step-title","tag":"h2","content":_vm.$t('keycloak-totp.step3.title')}}),_vm._v(" "),_c('magic-ui-text',{attrs:{"tag":"p","content":_vm.$t('keycloak-totp.step3.description')}}),_vm._v(" "),_c('form',{ref:"totp-form",staticStyle:{"display":"none"},attrs:{"action":_vm.totpAction,"method":"post"}},[_c('input',{attrs:{"type":"text","id":"totp","name":"totp","autocomplete":"off"}}),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"userLabel","name":"userLabel","autocomplete":"off"}})]),_vm._v(" "),(_vm.formConfig)?_c('magic-form-builder',{domProps:{"config":_vm.formConfig},on:{"form-submit":function($event){return _vm.submit($event.detail[0])}}}):_vm._e()],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-53acbeea_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-53acbeea";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
